import { render, staticRenderFns } from "./CCardNoticePanel.vue?vue&type=template&id=9fb971ec&scoped=true"
import script from "./CCardNoticePanel.vue?vue&type=script&lang=js"
export * from "./CCardNoticePanel.vue?vue&type=script&lang=js"
import style0 from "./CCardNoticePanel.vue?vue&type=style&index=0&id=9fb971ec&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb971ec",
  null
  
)

export default component.exports